import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeHighlight from 'rehype-highlight';
import remarkGfm from 'remark-gfm';

interface MarkdownRendererProps {
  content: string;
}

export default function MarkdownRenderer({ content }: MarkdownRendererProps) {
  function preprocessMathContent(content: string) {
    // convert \( ... \) to $...$ for inline math
    const inlineMathProcessed = content.replace(/\\\\?\((.+?)\\\\?\)/g, '$$$1$$');

    // convert \[ ... \] to $$...$$ for block math
    return inlineMathProcessed.replace(/\\\\?\[(.+?)\\\\?\]/g, '$$$$1$$$$');
  }

  return (
    <ReactMarkdown
      rehypePlugins={[rehypeKatex, rehypeHighlight]}
      remarkPlugins={[remarkMath, remarkGfm]}
    >
      {preprocessMathContent(content)}
    </ReactMarkdown>
  );
}
